import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PermissionsState } from './permissions.interface';

export const selectPermissionsState = createFeatureSelector<PermissionsState>('permissions');

// Main permissions selector - returns the entire permissions object
export const selectPermissions = createSelector(
	selectPermissionsState,
	(state) => state.permissions
);

export const selectPermissionsLoading = createSelector(
	selectPermissionsState,
	(state) => state.loading
);

export const selectPermissionsError = createSelector(
	selectPermissionsState,
	(state) => state.error
);
